export default {
  CONNECTED: 'connected',
  CONTEXTS: {
    UPLOADED_PHOTOS: 1,
    TAGGED_PHOTOS: 2,
    ALBUM_PHOTOS: 4,
    ALBUMS: 8,
  },
  RESOURCES: {
    PHOTOS: 'photos',
    ALBUMS: 'albums',
  },
  RES_TYPES: {
    UPLOADED: 'uploaded',
    TAGGED: 'tagged',
  },
};
